function ServiceItem({ id, image, name, aciklama }) {

  const aciklamaList = Array.isArray(aciklama) ? aciklama : [aciklama];

  return (
    <div id={id} className="serviceItem">
      <img src={image} alt={name} className="serviceImage" />

      <div className="serviceContent">
        <h2>{name}</h2>

        <div className="serviceDescription">
          {aciklamaList.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServiceItem;